import { useState as S, useCallback as g } from "react";
const C = (e) => {
  if (typeof document == "undefined")
    return null;
  const o = `; ${document.cookie}`.split(`; ${e}=`);
  if (o.length === 2) {
    const i = o.pop();
    if (i)
      return i.split(";").shift() || null;
  }
  return null;
}, d = (e, n, o) => {
  if (typeof document == "undefined")
    return;
  const {
    days: i = 365,
    domain: s = void 0,
    // Don't set domain for localhost
    path: p = "/",
    secure: c = window.location.protocol === "https:",
    sameSite: f = "Lax"
  } = o || {}, a = /* @__PURE__ */ new Date();
  a.setTime(a.getTime() + i * 24 * 60 * 60 * 1e3);
  let l = `${e}=${n}; expires=${a.toUTCString()}; path=${p}; SameSite=${f}`;
  s && (l += `; domain=${s}`), c && (l += "; Secure"), console.log("cookieString", l), document.cookie = l;
}, E = (e, n) => {
  if (typeof document == "undefined")
    return;
  const {
    domain: o = void 0,
    // Don't set domain for localhost
    path: i = "/"
  } = n || {};
  let s = `${e}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${i}`;
  o && (s += `; domain=${o}`), document.cookie = s;
}, U = (e, n, o) => {
  const [i, s] = S(!1), [p, c] = S(null), f = g(() => {
    try {
      const r = C(e);
      if (r === null) {
        const u = encodeURIComponent(JSON.stringify(n));
        return d(e, u, o), n;
      }
      return JSON.parse(decodeURIComponent(r));
    } catch (r) {
      const t = r instanceof Error ? r.message : String(r);
      console.warn(`Error parsing cookie "${e}":`, t);
      const u = encodeURIComponent(JSON.stringify(n));
      return d(e, u, o), n;
    }
  }, [e, n, o]), [a, l] = S(f), y = g(() => {
    try {
      s(!1), c(null);
      const r = C(e);
      return r === null ? n : JSON.parse(decodeURIComponent(r));
    } catch (r) {
      const t = r instanceof Error ? r.message : String(r);
      return console.warn(`Error parsing cookie "${e}":`, t), s(!0), c(t), n;
    }
  }, [e, n, s, c]), h = g(
    (r) => {
      try {
        if (s(!1), c(null), typeof r != "function") {
          console.error(
            `useCookieState("${e}") only accepts function updates. Use: setValue(prev => ({ ...prev, newProperty: value }))`
          );
          return;
        }
        const t = r(a || n);
        if (t === void 0) {
          console.warn(
            `Update function returned undefined for cookie "${e}". Using default value instead.`
          );
          const $ = n, m = encodeURIComponent(JSON.stringify($));
          d(e, m, o), l($);
          return;
        }
        const u = encodeURIComponent(JSON.stringify(t));
        d(e, u, o), l(t);
      } catch (t) {
        const u = t instanceof Error ? t.message : String(t);
        console.error(`Error setting cookie "${e}":`, u), s(!0), c(u);
      }
    },
    [e, o, n, a, s, c]
  ), v = g(() => {
    try {
      s(!1), c(null), E(e, o), l(n);
    } catch (r) {
      const t = r instanceof Error ? r.message : String(r);
      console.error(`Error deleting cookie "${e}":`, t), s(!0), c(t);
    }
  }, [e, o, n, s, c]);
  return {
    value: a,
    getValue: y,
    setValue: h,
    deleteValue: v,
    error: i,
    errorMessage: p
  };
}, I = U;
export {
  I as default,
  I as useCookieState
};
